module.exports = __webpack_public_path__ + "components/home-header/static/header-2--huge-9664a1b2368236003e799f89d873ed01.jpg";